import { gql } from "@apollo/client";import { useQuery } from "@apollo/client/react";
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import { MenuItem, MenuList } from '@mui/material';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import Cookies from 'universal-cookie';
import '../../../assets/css/App.css';
import ErrorDialog from '../../../components/ErrorDialog';
import { RenderIcon as Icon } from '../../../utils/icons';
import ItemLink from './itemLink';
import { DesktopOrTabletContainer, MobileContainer } from '../../../responsiveTools/ResponsiveContainers';
import { MobileNavBar } from './MobileNavBar/MobileNavBar';
import { useLogout } from "../../../components/hooks/useLogout";

import './navBar.scss';
const Accordion = styled((props) =>
<MuiAccordion disableGutters elevation={0} square {...props} />
)(({ theme }) => ({
  width: 200,
  border: '0px',
  borderBottom: '1pt solid white'
}));

const AccordionSummary = styled((props) =>
<MuiAccordionSummary
  expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.6rem' }} />}
  {...props} />

)(({ theme }) => ({
  width: 200,
  color: 'white',
  borderRadius: 5,
  backgroundColor:
  theme.palette.mode === 'dark' ?
  'rgba(255, 255, 255, .05)' :
  '#0063BE',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
    color: 'white'
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(0)
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    color: 'white'
  }
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(0),
  borderLeft: '1px solid rgba(0, 0, 0, .125)',
  borderRight: '1px solid rgba(0, 0, 0, .125)'
}));

export default function NavBar({
  // Se debe eliminar la prop iFrame cuando ya no se rendericen pantallas de tipo iframe, esta logica es temporal
  iFrame
}) {

  const idUsuario = parseInt(sessionStorage.getItem("idUsuario"), 10);
  const panelActual = sessionStorage.getItem("panelActual");

  const [expanded, setExpanded] = React.useState(panelActual);

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  useEffect(() => {
    sessionStorage.setItem("panelActual", expanded);
  }, [expanded]);

  // dlg de error
  const cookies = new Cookies();

  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  useEffect(() => {
    setOpenDlgError(mensajeError !== "");
  }, [mensajeError]);

  const QMenu = gql`
      query QMenu($idUsuario: Int!){
        menu(idUsuario: $idUsuario)
        {
          success,
          error,
          valorEsperado {
              idArea,
              descripcion,
              aplicaciones
              {
                  idApp,
                  descripcion,
                  descripcionConParam
                  url,
                  img,
                  pagina, 
                  orden,
                  iframe,
                  escritura,
                  dataPrivacy
              }
          }
        }            
    }`;

  const { data, error, loading } = useQuery(QMenu, {
    fetchPolicy: 'no-cache',
    variables: { idUsuario: idUsuario }
  });

  const logout = useLogout();

  const handleLogout = async () => {
    await logout();
    sessionStorage.clear();
    cookies.remove("accessToken");
    cookies.remove("idUsuario");
    cookies.remove("auditoria_filter_accion");
    cookies.remove("auditoria_filter_fechaDesde");
    cookies.remove("auditoria_filter_fechaHasta");
    window.location.replace('/');
  };

  const handleSetApp = (app) => {
    sessionStorage.setItem("appActual", app);
  };

  if (error) {
    // verifico si puedo acceder al storage (se mantendría la sesión)
    const token = sessionStorage.getItem("accessToken");
    if (token) {
      return (
        <>
          <ErrorDialog
            id="dlg-error-menu"
            open={true}
            onClose={handleLogout}
            mensaje="ERRORDB" />
          
        </>);

    } else {
      handleLogout();
    }
  }

  if (!loading && data != null) {
    if (data.menu.success) {
      const items = data.menu.valorEsperado;
      localStorage.setItem('navigationRoutes', JSON.stringify(items));
      return (
        <>
          <DesktopOrTabletContainer>
            <div className={`navbar-container ${iFrame ? 'frame-navbar' : ''}`}>
              {items.
              map((item) =>
              <Accordion
                key={item.idArea}
                expanded={expanded === `panel${item.idArea}`}
                onChange={handleChange(`panel${item.idArea}`)}>
                
                    <AccordionSummary aria-controls="panel`${item.idArea}}`d-content">
                      <div className='nav-item'>
                        <div style={{ boxSizing: 'box-content', verticalAlign: 'middle' }}>
                          <Icon index={item?.idArea} className='navbar-icon' sx={{ backgroundColor: 'green' }} />
                        </div>
                        <div>
                          <Typography sx={{ fontSize: '9pt', lineHeight: '14px' }}>{item.descripcion}</Typography>
                        </div>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      <MenuList>
                        {item.aplicaciones.
                    map((pagina, index) =>
                    <MenuItem
                      key={`id-${pagina.idApp}-url-${pagina.url}-index-${index}`}
                      className={sessionStorage.getItem("appActual") == pagina.descripcion ? 'active-option' : ''}>
                      
                              {pagina.iframe && <ItemLink pagina={pagina} />}
                              {!pagina.iframe &&
                      <NavLink
                        style={{
                          color: "black",
                          display: "block",
                          fontSize: "10pt",
                          margin: "0px 10px",
                          textDecoration: "none",
                          width: 140,
                          whiteSpace: "pre-wrap",
                          wordWrap: "break-word"
                        }}
                        onClick={() => handleSetApp(pagina.descripcion)}
                        to={pagina.url}
                        key={pagina.url}>
                        
                                  {pagina.descripcion}
                                </NavLink>
                      }
                            </MenuItem>
                    )}
                      </MenuList>
                    </AccordionDetails>
                  </Accordion>
              )}
            </div>
          </DesktopOrTabletContainer>
          <MobileContainer>
            <MobileNavBar options={items} />
          </MobileContainer>
        </>);
    } else {
      // mostrar error
      // return (
      //   <ErrorDialog
      //     id="dlg-error-menu"
      //     open={!data.menu.success}
      //     onClose={handleLogout}
      //     mensaje={data.menu.error} />);
    }
  }
}